var SolutionsController = (function () {
    function SolutionsController(searchStateService) {
        this.searchStateService = searchStateService;
        this.solutions = [];
    }
    Object.defineProperty(SolutionsController.prototype, "limit", {
        get: function () {
            return this.searchStateService.solutionsLimit;
        },
        enumerable: false,
        configurable: true
    });
    SolutionsController.prototype.$onInit = function () {
        this.searchStateService.resetSolutionsLimit();
        this.searchStateService.solutionsMaxLimit = this.solutions.length;
    };
    SolutionsController.prototype.displayMore = function () {
        var _a;
        if (this.limit > ((_a = this.solutions) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        var _b = this.searchStateService, solutionsLimit = _b.solutionsLimit, solutionsLimitStep = _b.solutionsLimitStep;
        this.searchStateService.setSolutionsLimit(solutionsLimit + solutionsLimitStep);
    };
    SolutionsController.$inject = ['searchStateService'];
    return SolutionsController;
}());
export var SolutionsComponent = {
    bindings: {
        isListView: '<',
        solutions: '<',
        thirdPartyDevices: '<',
    },
    controller: SolutionsController,
    templateUrl: 'compatibilityguide/ng-templates/feature/search/solutions',
};
export default SolutionsComponent;
